import { jsx } from '@emotion/core'; // @ts-ignore

import { info_16 } from '@trustpilot/icons';
import { COLORS, GRID } from '../../constants';
import { Type, Popover, Icon } from '../..';
export var LabelWithTooltip = function LabelWithTooltip(_a) {
  var tooltip = _a.tooltip,
      children = _a.children;
  return jsx(Type, {
    css: {
      display: 'inline-flex',
      alignItems: 'center'
    }
  }, children, jsx(Popover, {
    content: tooltip
  }, jsx("span", {
    css: {
      display: 'flex',
      marginLeft: GRID.xsmall
    }
  }, jsx(Icon, {
    color: COLORS.grays.lighter,
    content: info_16
  }))));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/NumberHighlightCard/Label.js
// module id = 1222
// module chunks = 0